"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var widget_fixed_height_option_html_1 = __importDefault(require("./widget-fixed-height-option.html"));
var WidgetFixedHeightController = /** @class */ (function () {
    function WidgetFixedHeightController() {
        var _this = this;
        this.$ctrl = this;
        angular_1.extend(this.$ctrl, {
            // @ts-ignore
            change: function (useFixedHeight) {
                // @ts-ignore
                _this.$ctrl.onChange({
                    $value: useFixedHeight
                });
            }
        });
    }
    return WidgetFixedHeightController;
}());
(function (module) {
    module.component('prWidgetFixedHeightOption', {
        templateUrl: widget_fixed_height_option_html_1.default,
        controller: WidgetFixedHeightController,
        bindings: {
            useFixedHeight: '<',
            onChange: '&'
        }
    });
})(angular_1.module('qualtrics.pr'));
